import React, { useState } from "react"
import { graphql } from "gatsby"
import Layout from "../components/Layout"
import LeafletMap from '../components/LeafletMap';
import placeStyles from "../styles/templates/place.module.scss"


export default function Map(props) {
  const data = props.data.markdownRemark;
  const position = [
    [-31, -56.8],
    [-34.5, -55]
  ]
  /*
  const [current, setCurrent] = useState('all');
  const [position, setPosition] = useState([
    [-31, -56.8],
    [-34.5, -55]
  ])

  const mvd = () => {
    setPosition([
    [-34.868, -56.1929],
    [-34.928, -56.1329]
  ]);
  setCurrent('mvd');
  }
  const nInterior = () => {
    setPosition([
    [-30.5, -57.75],
    [-32.5, -55.75]
  ])
  setCurrent('nInterior');
  }
  const cInterior = () => {
    setPosition([
    [-32.0579, -56.8345],
    [-34.6605, -53.3628]
  ])
  setCurrent('cInterior');
  }
  const west = () => {
    setPosition([
    [-33.1292, -58.6252],
    [-34.6521, -56.2659]
  ])
  setCurrent('west');
  }
  const maldonado = () => {
    setPosition([
    [-34.199, -55.5346],
    [-34.9093, -54.3083]
  ])
  setCurrent('maldonado');
  }
  const canelones = () => {
   setPosition([
   [-34.2115, -56.4287],
   [-34.8867, -55.4015]
  ])
  setCurrent('canelones');
  }
  const rocha = () => {
   setPosition([
   [-33.5422, -55.0094],
   [-34.8619, -53.2927]
  ])
  setCurrent('rocha');
  }
  
  const all = () => {
    setPosition([
    [-31, -56.8],
    [-34.5, -55]
  ]);
  setCurrent('all');
  }
*/
  return (
    <Layout>

      <article id="map" className={placeStyles.place}>
        {typeof window !== 'undefined' &&
         <LeafletMap bounds={position} />
        }
        <div className={placeStyles.button_group}>
          
                   
        </div> 
        <div
          className={placeStyles.place__body}
          dangerouslySetInnerHTML={{ __html: data.html }}
        ></div>
        
      </article>
    </Layout>
  )
}


export const getMapData = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      fields {
        slug
      }
      frontmatter {
        title
        author
        hero_image {
          childImageSharp {
            fluid(maxWidth: 1000) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
      html
    }
  }
`

/*
<button 
            onClick={all} 
            className={current === 'all' ? placeStyles.active : placeStyles.not_active}>
            All
          </button>
          <button 
            onClick={mvd} 
            className={current === 'mvd' ? placeStyles.active : placeStyles.not_active}>
            Montevideo
          </button>
       <button 
            onClick={canelones} 
            className={current === 'canelones' ? placeStyles.active : placeStyles.not_active}>
            Canelones
          </button>
          <button 
            onClick={maldonado} 
            className={current === 'maldonado' ? placeStyles.active : placeStyles.not_active}>
            Maldonado
          </button>
          <button 
            onClick={rocha}
            className={current === 'rocha' ? placeStyles.active : placeStyles.not_active}>
            Rocha
          </button>
          <button 
            onClick={west}
            className={current === 'west' ? placeStyles.active : placeStyles.not_active}>
            West
          </button>
          <button 
            onClick={nInterior} 
            className={current === 'nInterior' ? placeStyles.active : placeStyles.not_active}>
            N.Interior
          </button>
          <button 
            onClick={cInterior}
            className={current === 'cInterior' ? placeStyles.active : placeStyles.not_active}>
            C.Interior
          </button> 
        */